/**
 * Customers Module
 *
 * Handles customer-specific functionality.
 * Most filter/bulk functionality is handled by core modules (filters.js, bulk-actions.js).
 */

import { ready } from '../utils/dom.js';

const BASE_URL = '/customers';

/**
 * Apply status filter
 */
export function applyStatusFilter(select) {
    const status = select.value;
    const params = new URLSearchParams();

    if (status) params.append('status', status);

    window.location.href = BASE_URL + (params.toString() ? '?' + params.toString() : '');
}

/**
 * Clear filters
 */
export function clearFilters() {
    window.location.href = BASE_URL;
}

// Expose globally for legacy onclick handlers
window.applyStatusFilter = window.applyStatusFilter || applyStatusFilter;
window.clearFilters = window.clearFilters || clearFilters;

export default {
    applyStatusFilter,
    clearFilters
};
